// extracted by mini-css-extract-plugin
export default {"actionButton":"FcfpptkHfPZySD5FKfHU","actionTrashButton":"yNhvyXM_kUxsjxvcxfJL","actionTrashIcon":"Re_23wXEcxjYuOoaI1PA"};